<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" id="dedication">
<div class="text" id="dedication-text">
<p class="first first-in-chapter first-full-width dedication-content">To Timothy and Georgia ,</p>
<p class="subsq dedication-content">With love bigger than the Universe and with apologies for the times I get things wrong. I can’t apologise for the question mark tank top though; you are both just going to have to come to terms with seeing me wear that in public.</p>
<p class="subsq dedication-content">God bless xx</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?5840f52d